import { useAnalytics } from 'src/components/AnalyticsProvider/AnalyticsProvider';
import { TPromptSettingsDropdownItemName } from '../types';

export const usePromptHeaderAnalytics = () => {
  const { sendEvent } = useAnalytics();

  const sendShareButtonClickEvent = () => {
    sendEvent('prompt_share_button_click');
  };

  const sendPromptSettingsDropdownOpenEvent = () => {
    sendEvent('prompt_settings_dropdown_open');
  };
  const sendPromptSettingsDropdownCloseEvent = () => {
    sendEvent('prompt_settings_dropdown_close');
  };

  const sendPromptSettingsDropdownItemClickEvent = (itemName: TPromptSettingsDropdownItemName) => {
    sendEvent('prompt_settings_dropdown_item_click', { item_name: itemName });
  };

  return {
    sendShareButtonClickEvent,
    sendPromptSettingsDropdownOpenEvent,
    sendPromptSettingsDropdownCloseEvent,
    sendPromptSettingsDropdownItemClickEvent,
  };
};
